import {useContext} from 'react'
import { isLogin } from '../App'
function useIsLogin() {
    return useContext(isLogin)
}

export {useIsLogin}
